<div class="dmsans">
  <div *ngIf="userData && (!draftData || draftData?.status_flag === 7)" class="home-v2">
    <app-component-loader [load]="true" selector="app-home-v2"></app-component-loader>
  </div>

  <div *ngIf="!userData || (draftData && draftData?.status_flag !== 7)" class="portrait-view">
    <div class="banner">
      <app-home-v2-banner [info]="info" [type]="'non_logged_in'"></app-home-v2-banner>
    </div>
    <div class="desktop_bg">
      <div class="urgent-need-non-home" *ngIf="freqVisitedCampaigns?.length">
        <app-urgent-need-slide [useGlide]="isMobile ? false : true" [customNav]="true" [hideClause]="true" [title]="'Your Journey of Change Starts Here !'" [freqVisitedCampaigns]="freqVisitedCampaigns"></app-urgent-need-slide>
      </div>
    </div>

    <div class="sip-pitch-card-wrapper">
      <app-sip-pitch-card-home/>
    </div>

    <div class="our-success-stories">
      <app-our-success-stories/>
    </div>

    <div class="know-more">
      <div class="line1"></div>
      <div class="text">Know more about Ketto</div>
      <div class="line1"></div>
    </div>

    <div inViewport class="sac-flow-wrapper" (inViewportAction)="loadComponent($event,'sacflow')"
      [inViewportOptions]="{ threshold: [700] }">
      <app-sacflow-v2 *ngIf="componentInView.sacflow"></app-sacflow-v2>
    </div>

    <div class="app-mcd-pitch">
      <span class="banner-title">
        Manage your fundraisers on the go
      </span>
      <app-download-app-banner-v3/>
    </div>


    <div class="causes_bg">
      <div inViewport (inViewportAction)="loadComponent($event,'causes')" [inViewportOptions]="{ threshold: [700] }">
        <app-causes-v3 *ngIf="componentInView.causes"></app-causes-v3>
      </div>
    </div>

    <div class="why-choose">
      <app-why-ketto showCustomArrows="true" [showArrows]="isMobile ? false : true"></app-why-ketto>
    </div>

    <div class="urgent-need-non-home">
      <app-urgent-need-slide [useGlide]="isMobile ? false : true" [customNav]="isMobile ? false : true"></app-urgent-need-slide>
    </div>

    <div class='success-stories-v2'>
      <app-success-stories-v2/>
    </div>

    <div class="featuredIn" inViewport (inViewportAction)="loadComponent($event,'featuredin')" [inViewportOptions]="{ threshold: [1000] }">
      <app-featuredin [showCustomArrows]="true" *ngIf="componentInView.featuredin"></app-featuredin>
    </div>

    <div class="spread-love" *ngIf="isMobile">
      <div class="title">
        <div class="text">Keep Spreading Love!</div>
        <div class="logo"><img loading="lazy" [attr.data-src]="'/assets/images/home-v2/heart.png'" alt="heart"></div>
      </div>
      <div class="sub-text">With Ketto’s Social Impact Plan</div>
    </div>

  </div>
  <div *ngIf="isMobile">
    <app-landscape-view/>
  </div>
</div>